import React from 'react'
import { createRoot } from 'react-dom/client'
import SignReact from '../main_app/SignReact'

document.addEventListener('DOMContentLoaded', () => {
  const node = document.getElementById('sign-react')
  if (node) {
    const data = JSON.parse(node.getAttribute('data'))
    const root = createRoot(node)
    root.render(<SignReact {...data} />)
  }
})
